export default __webpack_public_path__ + "static/media/copy-svgrepo-com.4f3a53d5.svg";